import { createRouter, createWebHistory } from 'vue-router'
import Home from '../views/Home.vue'
import Homa from '../views/Homa.vue'
import Profile from '../views/Profile.vue'
import Foods from '../views/Foods.vue'
import Meals from '../views/Meals.vue'
import NotFound from '../views/NotFound.vue'

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/perfil',
    name: 'Perfil',
    component: Profile
  },
  {
    path: '/homa',
    name: 'Homa',
    component: Homa
  },
  {
    path: '/alimentos',
    name: 'Alimentos',
    component: Foods
  },
  {
    path: '/refeicoes',
    name: 'Refeições',
    component: Meals
  },
  {
    path: '/about',
    name: 'About',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  },
  {
    path: "/:catchAll(.*)",
      component: NotFound,
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
